export const resolveCategoryNames = (categories, allCategories) => {
  const titleById = Object.fromEntries(
    allCategories?.map((category) => [category.id, category.title]) ?? []
  );

  return (categories ?? [])
    .map((category) => titleById[category.id])
    .filter(Boolean);
};
